(() => {
  const normalize = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      let path = url.pathname.replace(/\/+$/, '') || '/';
      return url.origin === window.location.origin ? path : null;
    } catch (_) {
      return null;
    }
  };

  const markCurrentLinks = (root = document) => {
    const current = normalize(window.location.href);
    if (!current) return;
    root.querySelectorAll('.kt6-header a[href], .kt15-mobile-nav a[href], .kt6-footer a[href]').forEach((link) => {
      const path = normalize(link.href);
      if (!path || path === '/' || path !== current) return;
      link.setAttribute('aria-current', 'page');
    });
  };

  const init = () => markCurrentLinks();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', (event) => markCurrentLinks(event.target));
})();
